import { createAction } from '@reduxjs/toolkit';

export const onToast = createAction('[Toast] onToast');
export const clearToast = createAction('[Toast] clearToast');
